export { TransparentPricingDS, default } from './transparent-pricing-ds'
export type { TransparentPricingDSProps, TransparentItemProps } from './transparent-pricing-ds.types'
